module.exports = __webpack_public_path__ + "static/media/user-solid-circle.93b9a6e9.svg";